/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */

import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  notification: () => _t(translations.notifications.notification),
  markAllAsRead: () => _t(translations.notifications.markAllAsRead),
  archiveRead: () => _t(translations.notifications.archiveRead),
  viewAll: () => _t(translations.notifications.viewAll),
  actionTaken: () => _t(translations.notifications.actionTaken),
};
